import { createSlice } from '@reduxjs/toolkit'
import { DROPDOWN_LIST } from 'app/types'
import { VENDOR, DEPARTMENT, PROJECT } from 'types'

const initialState = {
  [VENDOR]: [],
  [PROJECT]: [],
  [DEPARTMENT]: []
}
export const dropdownListSlice = createSlice({
  name: DROPDOWN_LIST,
  initialState: { ...initialState },
  reducers: {
    setDropdowns: (state, action) => {
      const { payload } = action
      const { fieldName, data } = payload
      state[fieldName] = data
    },
    clearDropdowns: state => {
      state[VENDOR] = []
      state[PROJECT] = []
      state[DEPARTMENT] = []
    }
  }
})

export const { setDropdowns, clearDropdowns } = dropdownListSlice.actions
export const selectDropdownListSlice = state => state[DROPDOWN_LIST]
export default dropdownListSlice.reducer
